import { render, staticRenderFns } from "./AccordionNav.vue?vue&type=template&id=4c470b64&scoped=true"
import script from "./AccordionNav.js?vue&type=script&lang=js&external"
export * from "./AccordionNav.js?vue&type=script&lang=js&external"
import style0 from "./AccordionNav.scss?vue&type=style&index=0&id=4c470b64&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c470b64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotButton: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default,HotAccordionNavItem: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/AccordionNavItem/AccordionNavItem.vue').default})
